import "./addDuty.css";
import { TimeTextInput } from "./timeTextInput";
import dayjs from "dayjs";
import { holidayChecks } from "@src/util/holidayChecks";
import utc from 'dayjs/plugin/utc';
import duration from 'dayjs/plugin/duration';
import { CaretDownFilled, CarFilled, CarOutlined, LoadingOutlined, UserOutlined } from "@ant-design/icons"
import { faCar, faChevronDown, faChevronUp, faClockRotateLeft, faClose, faDedent, faEllipsisVertical, faExternalLink, faLayerGroup, faLocation, faLocationPin, faMapLocation, faMapPin, faPersonBooth, faPersonBurst, faPersonDigging, faPlus, faSearch, faStreetView, faTimes, faTrainTram, faWandMagicSparkles } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Checkbox, Form, Input, InputNumber, Modal, Select, Avatar, Spin, Tabs, TimePicker, Dropdown, Menu, Tag, Tooltip } from "antd";
import { blockNonIntegerKeys, splitBreakDuration } from "@src/util/breakDuration/breakDuration";
import React, { useEffect, useState, useRef } from "react"
import { shiftTypeQuery } from "@src/util/query/shiftType.query";
import { SHOW_HOUR_TYPE, defaultHourTypeId } from "@src/util/hourType";
import { getPayLevelQuery } from "@src/util/query/paylevel.query";
import { useApolloClient, useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { newScheduleMutation } from "@src/util/mutation/schedule.mutation";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "@src/components/spinner";
import Swal from "sweetalert2";
import { setNotification } from '@src/middleware/redux/reducers/notification.reducer';
import { getReportTemplates } from '@src/util/query/reportTemplate.query';
import { CheckFailureModal } from "../checkFail.model";
import { newScheduleTimesMutation } from "@src/util/mutation/scheduleTimes.mutation";
import { CheckEmployeeDuplicateQuery, EmployeeObjectQuery, getEmployeeForScheduleSearchQuery, getEmployeeForTrainedUnTrained } from "@src/util/query/employee.query";
import { AddEmployeeMutation, RestoreEmployeeMutation } from "@src/util/mutation/employee.mutation";
import { newScheduleCheckMutation } from "@src/util/mutation/scheduleChecks.mutation";
import { dutyTypesForSite, isDirectMobileDriver, scheduleCheckFailureList } from "@src/util/scheduleCheckFailureList";
import { getSystemHolidayQuery } from "@src/util/query/systemHoliday.query";
import { getScheduledJobById } from "@src/util/query/schedule.query";
import { getAgencies } from "@src/util/query/agency.query";
import { updateScheduleMutation } from "@src/util/mutation/schedule.mutation";
import { updateScheduleTimesMutation } from "@src/util/mutation/scheduleTimes.mutation";
import { scheduleCheckQuery } from "../../../util/query/scheduleCheck.query";
import { TaskAssignmentModal } from "./taskAssignment.modal";
import { TaskAssignmentModalGeneric } from "./taskAssignment.modal.generic";
import { AssignNewScheduleTaskBulkMutation } from "@src/util/mutation/scheduleTaskAssignment.mutation";
import { MapPin, TrainFrontIcon } from "lucide-react";
import { getEmployeeByBranchId } from "@src/util/query/employee.query";
import { ScheduleAssistantModal } from "../scheduleAssistant/scheduleAssistant.modal";
import { FormDrawer } from "../../formDrawer";
import { objectType } from "@src/util/types/object.types";
import { HelpLink } from "@src/components/helpLink/helpLink";




export const AddDutyModal = ({
    dutyModal:{visible=true, title, site, area},
    editDutyId="",
    close, scheduleRefetch,
    prefillShiftStart="",
    prefillShiftEnd="",
    prefillDutyTypeId="",
    prefillNumberOfDuties=null,
})=>{
    
    dayjs.extend(utc);
    dayjs.extend(duration);


    const [allowedSkilledForSpecificArea, setAllowedSkillsForSpecificArea] = useState([]);
    const [optionalSkilledForSpecificArea, setOptionalSkillsForSpecificArea] = useState([]);

    useEffect(()=>{
        if(site?.siteskills?.length>0){

            setAllowedSkillsForSpecificArea(site?.siteskills?.filter((areaSkill)=>areaSkill?.areaId==area?._id && areaSkill?.status==true && !areaSkill?.optional)?.map((skill)=>skill?.skillId));
            setOptionalSkillsForSpecificArea(site?.siteskills?.filter((areaSkill)=>areaSkill?.areaId==area?._id && areaSkill?.optional)?.map((skill)=>skill?.skillId));
            console.log(
                site?.siteskills?.filter((areaSkill)=>areaSkill?.areaId==area?._id && areaSkill?.status==true && !areaSkill?.optional),
                "site?."
            )
        }
    },[site, area]);


    // extract duty details if we are editing particular duty

    const {data: editDutyData, loading: editDutyDataLoading} = useQuery(getScheduledJobById, {
        variables: {
            jobId: editDutyId
        },
        skip: editDutyId?.length==0,
        fetchPolicy:'network-only'
    });



    const {Option} = Select;
    const {data: dutyTypeData, loading: dutyTypeLoading, refetchDutyType} = useQuery(getPayLevelQuery,{
        fetchPolicy: 'network-only',
    });

    console.log(dutyTypeData, "dutyTypeData")


    const {data: hourTypeData, loading: hourTypeDataLoading, refetch: refetchHourType} = useQuery(shiftTypeQuery);

    const [dutyType, setDutyType] = useState(null);
    const [alarmType, setAlarmType] = useState(null);
    const [hourType, setHourType] = useState(null);

    // Hour Type is hidden (see util/hourType) - a duty without one gets Standard Hour
    useEffect(() => {
        if (!hourType && hourTypeData?.getShiftType?.response?.length) {
            setHourType(defaultHourTypeId(hourTypeData?.getShiftType?.response));
        }
    }, [hourTypeData, hourType]);

    const [shiftStartTime, setShiftStartTime] = useState("");
    const [shiftEndTime, setShiftEndTime] = useState("");

    useEffect(() => {
        if (prefillShiftStart) setShiftStartTime(prefillShiftStart);
        if (prefillShiftEnd) setShiftEndTime(prefillShiftEnd);
        if (prefillDutyTypeId) setDutyType(prefillDutyTypeId);
        if (prefillNumberOfDuties && prefillNumberOfDuties > 0) setDuties(prefillNumberOfDuties);
    }, [prefillShiftStart, prefillShiftEnd, prefillDutyTypeId, prefillNumberOfDuties]);

    const [unPaidBreakHour, setUnPaidBreakHour] = useState("");
    const [unPaidBreakMintue, setUnPaidBreakMintue] = useState("");

    const [unPaidBillHour, setUnPaidBillHour] = useState("");
    const [unPaidBillMintue, setUnPaidBillMintue] = useState("");

    const [bookingRef, setBookingRef] = useState("");
    const [supplierRef, setSupplierRef] = useState("");

    // assigned employee
    const [assignedEmployee, setAssignedEmployee] = useState();
    const [assignedAgency, setAssignedAgency] = useState(null);

    const [duties, setDuties] = useState(1);


    
    const [newSchedule, {loading: newScheduleLoading}] = useMutation(newScheduleMutation);
    const [employeeSlider, setEmployeeSlider] = useState(false);

   
    const [shiftTime, setShiftTime] = useState("");

    useEffect(()=>{
        if(shiftTime){
            const endTime  = shiftTime?.secondDate? 
                (dayjs(shiftTime?.secondDate+" "+shiftEndTime, "DD/MM/YYYY HH:mm"))
                :
                (dayjs(shiftTime?.firstDate+" "+shiftEndTime, "DD/MM/YYYY HH:mm"));

            const startTime = dayjs(shiftTime?.firstDate+" "+shiftStartTime, "DD/MM/YYYY HH:mm");
        }
    },[shiftTime]);
    
    useEffect(()=>{
        if(duties > 1){
            setEmployeeSlider(false);
        } else if(dutyType?.length>0 && hourType?.length>0 && shiftStartTime?.length>0 && shiftEndTime?.length>0){
            setEmployeeSlider(true);
        }else{
            setEmployeeSlider(false);
        }
    }, [dutyType, hourType, shiftStartTime, shiftEndTime, duties]);

    const [trainedEmp, setTrainedEmp] = useState([]);
    const [otherEmp, setOtherEmp] = useState([]);

    const [search, setSearch] = useState("");

    const [debouncedSearch, setDebouncedSearch] = useState("");

    useEffect(() => {
    const timeout = setTimeout(() => {
        setDebouncedSearch(search);
    }, 500); // 500ms debounce delay

    return () => clearTimeout(timeout);
    }, [search]);


    const handelSearch = (keyword)=>{
        setSearch(keyword);
    };

    const [trainUnTrainEmpParam, setTrainedUnTrainedEmpParam] = useState({});

    const {data: trainedUnTrainedData, loading: trainUnTrainedLoading, refetch: trainUnTrainedRefetch} = useQuery(getEmployeeForTrainedUnTrained,{
        variables:{
            input:{
                siteId: site?._id,
                schedule: trainUnTrainEmpParam,
            }
        },
        skip: trainUnTrainEmpParam && Object.keys(trainUnTrainEmpParam)?.length==0,
        fetchPolicy:'network-only'
    });
    
    useEffect(()=>{
        if(shiftTime!=""){
            const endDate = 
                shiftTime?.secondDate? 
                dayjs(shiftTime?.secondDate+" "+shiftEndTime, "DD/MM/YYYY HH:mm")
                :
                dayjs(shiftTime?.firstDate+" "+shiftEndTime, "DD/MM/YYYY HH:mm");

            const startDate = dayjs(shiftTime?.firstDate+" "+shiftStartTime, "DD/MM/YYYY HH:mm");
                
            setTrainedUnTrainedEmpParam({startDate, endDate});
            // getEmployeeOnSearch({fetchPolicy: 'cache-and-network',
            //     variables: {
            //         input: {
            //             filters:  null,
            //             schedule: {startDate, endDate}
            //         }
            //     },
            //     fetchPolicy: 'cache-and-network',
            // });

        }
    }, [shiftTime]);

    const [getScheduleCheckFailure, {data, loading:scheduleCheckFailureLoading}] = useLazyQuery(scheduleCheckQuery);

    // get trained employes
    useEffect(()=>{
        if(shiftStartTime &&  shiftEndTime && trainedUnTrainedData?.getEmployeeForTrainedUnTrained?.response && !trainUnTrainedLoading){
            trainedUnTrainedData?.getEmployeeForTrainedUnTrained?.response?.map(async (emp)=>{
                await setTimeout(()=>{},100);
                setFailureChecks(null);
                if(!scheduleCheckFailureLoading){
                    await checkEmployeeIfSuitable(emp, true);
                }
                setFailureChecks(null);
                await setTimeout(()=>{},100);
            });
        }else{
            setTrainedEmp([]);
            setOtherEmp([]);
        }
    },[shiftStartTime, trainedUnTrainedData, shiftEndTime, scheduleCheckFailureLoading]);

    // check employee from search if it is suitable or not for specific job
    const checkEmployeeIfSuitable = async (emp, accessFromOutside=false)=>{

        const { empHolidayCheck, empPendingHoliday } = holidayChecks(emp, title);
        // if site block or not
        let blockedSite = false;
        if(emp?.blockedSites?.length>0){
            blockedSite = emp?.blockedSites?.find((bs)=>bs?.siteId==site?._id)? true: false;
        }
        // branch check
        const isBranchExist = emp?.branch?.find((b)=>b?._id==site?.branchDetail?._id);
        const branchCheck = isBranchExist? false : true;

        //============ rest period check

        // const specificArea = emp?.schedules?.find((schedule)=>schedule?.siteAreaId==area?._id);
        
        let restPeriodCheck = false;

        
        let alreadyWorking = false;
        if(emp?.scheduleCheck?.response?.length>0 && editDutyId){
            


            const shiftStartDateTime = dayjs(shiftTime?.firstDate + " " + shiftStartTime, "DD/MM/YYYY HH:mm");

            const shiftEndDateTime = shiftTime?.secondDate
                ? dayjs(shiftTime?.secondDate + " " + shiftEndTime, "DD/MM/YYYY HH:mm")
                : dayjs(shiftTime?.firstDate + " " + shiftEndTime, "DD/MM/YYYY HH:mm");


            const todaySchedule = emp?.scheduleCheck?.response?.[0];
            // Example: two dates to check
            const checkStartDateTime = dayjs(todaySchedule?.firstDate);
            const checkEndDateTime   = dayjs(todaySchedule?.shiftEndDateTime);

            // Check if both dates are inside the range (inclusive)
            const isInsideShift = 
                checkStartDateTime.isBetween(shiftStartDateTime, shiftEndDateTime, null, "[]") &&
                checkEndDateTime.isBetween(shiftStartDateTime, shiftEndDateTime, null, "[]");

            alreadyWorking = isInsideShift;



        }else if(emp?.scheduleCheck?.response?.length>0){
        

            const shiftStartDateTime = dayjs(shiftTime?.firstDate + " " + shiftStartTime, "DD/MM/YYYY HH:mm");

            const shiftEndDateTime = shiftTime?.secondDate
                ? dayjs(shiftTime?.secondDate + " " + shiftEndTime, "DD/MM/YYYY HH:mm")
                : dayjs(shiftTime?.firstDate + " " + shiftEndTime, "DD/MM/YYYY HH:mm");


            const todaySchedule = emp?.scheduleCheck?.response?.[0];
            // Example: two dates to check
            const checkStartDateTime = dayjs(todaySchedule?.firstDate);
            const checkEndDateTime   = dayjs(todaySchedule?.shiftEndDateTime);

            // Check if both dates are inside the range (inclusive)
            const isInsideShift = 
                checkStartDateTime.isBetween(shiftStartDateTime, shiftEndDateTime, null, "[]") &&
                checkEndDateTime.isBetween(shiftStartDateTime, shiftEndDateTime, null, "[]");


            alreadyWorking = isInsideShift;

        }


        //============ rest period check terminated
        
        //=================== duty check / experience check
        const trainingCheck= emp?.trainedEmployeeOnSite?.find((te)=>te?.siteId==site?._id)? false: true;

        //=================== duty check / experience check terminated

        //================== skill check 
        let skillCheck = allowedSkilledForSpecificArea?.length==0? false : !allowedSkilledForSpecificArea.every((areaSkill)=> emp?.employeeskills?.find((empSkill)=>empSkill?.skill==areaSkill && empSkill?.isArchive!=true));
        const optionalSkillCheck = optionalSkilledForSpecificArea?.length==0? false : !optionalSkilledForSpecificArea.some((areaSkill)=> emp?.employeeskills?.find((empSkill)=>empSkill?.skill==areaSkill && empSkill?.isArchive!=true));
        console.log(optionalSkillCheck, "skillCheck", skillCheck, "allowedSkilledForSpecificArea", allowedSkilledForSpecificArea, emp?.employeeskills)
        // if(optionalSkillCheck){
        //     skillCheck = true;
        // }
        
        //================== skill check terminated
        
        //======================= visa expiry check
        const visaExpiryCheck = emp?.metadata?.requirevisa=="Yes"? 
            emp?.metadata?.visaexpirydate? 
            dayjs(emp?.metadata?.visaexpirydate, "YYYY/MM/DD").isAfter(dayjs())? false: true
            : true  
        // this check will be true if visa required and date is empty
        :false
        //======================= visa expiry check terminated

        // skill expiry check
        let skillExpiryCheck = false;
        const matchedSkill = emp?.employeeskills?.filter((empSkill)=> 
            [...allowedSkilledForSpecificArea, ...optionalSkilledForSpecificArea]?.find((skill)=>skill==empSkill?.skill) && empSkill?.isArchive!=true)?.
            filter((skill)=> skill?.fields?.find((f)=>f?.name=="expirydate"))
            .map((skill)=> {
                const isExist = skill?.fields?.find((f)=>f?.name=="expirydate");
                if(isExist){
                    return isExist.value;
                }
            });
            
        if(matchedSkill?.length>0){
            skillExpiryCheck = matchedSkill?.every((date)=> dayjs(date).local().isAfter(dayjs())) ? false : true
        }
            
        
        // hard check: a direct-jobs mobile driver is never put on a duty
        const directDriverCheck = isDirectMobileDriver(emp);
        if(directDriverCheck || alreadyWorking || restPeriodCheck || skillCheck || trainingCheck || skillExpiryCheck || visaExpiryCheck || branchCheck || blockedSite || empHolidayCheck || empPendingHoliday){
            setFailureChecks({directDriverCheck, alreadyWorking, restPeriodCheck, skillCheck, trainingCheck, skillExpiryCheck, visaExpiryCheck, branchCheck, empHolidayCheck, empPendingHoliday, employeeData: {...emp, site:site?._id}, blockedSite});
            if(accessFromOutside){
                setOtherEmp((prevOtherEmp) => {
                    const isExist = prevOtherEmp.find((oemp) => oemp?._id === emp?._id);
                    return isExist
                        ? prevOtherEmp.map((oemp) => (oemp?._id === emp?._id ? emp : oemp))
                        : [...prevOtherEmp, emp];
                });
        
                setTrainedEmp((prevTrainedEmp) =>
                    prevTrainedEmp.filter((temp) => temp?._id !== emp?._id)
                );

            }else{
                setCheckFailVisible(true);
                setSearch("");
            }
            
        }else{
            if(accessFromOutside){
                
                setTrainedEmp((prevTrainedEmp) => {
                    const isExist = prevTrainedEmp.find((temp) => temp?._id === emp?._id);
                    return isExist
                        ? prevTrainedEmp.map((temp) => (temp?._id === emp?._id ? emp : temp))
                        : [...prevTrainedEmp, emp];
                });
        
                setOtherEmp((prevOtherEmp) =>
                    prevOtherEmp.filter((oemp) => oemp?._id !== emp?._id)
                );


            }else{
                setSearch("");
                setAssignedEmployee({_id:emp?._id, isSuitable: 0, isFromSearch:1,  emp})

            }
            if(editDutyId==""){
                setAssignedAgency(null);
            }
        }


        
    };


    const calculateTimeDifference = (time1, time2) => {
        // Define the start and end times
        const startTime = dayjs(title?.format("DD/MM/YYYY").toString() + " " + time1, 'DD/MM/YYYY HH:mm').set('second', 0).set('millisecond', 0);
        let endTime = dayjs(title?.format("DD/MM/YYYY").toString() + " " + time2, 'DD/MM/YYYY HH:mm').set('second', 0).set('millisecond', 0);
    
        // Handle case where endTime is before startTime (next day)
        if (endTime.isBefore(startTime)) {
            endTime = endTime.add(1, 'day');  // Adjust if end time is on the next day
        }
    
        // Calculate the difference in hours and minutes between startTime and endTime
        const diffInMilliseconds = endTime.diff(startTime);
        const diffInHours = diffInMilliseconds / (1000 * 60 * 60);
        const hours = Math.floor(diffInHours);
        const minutes = Math.round((diffInHours - hours) * 60);
    
        // Check if the time period crosses midnight
        const midnight = title.endOf('day').set('second', 0).set('millisecond', 0);
        const firstHourRaw = endTime.isAfter(midnight) 
            ? ((midnight.diff(startTime, 'minute')+1)/60 )
            : diffInHours;  // If no cross to next day, use total time
       
        // Adjust firstHour calculation
        const firstHour = firstHourRaw < 0 ? 0 : firstHourRaw;  // Make sure it's not negative
    
        // Prepare the response based on whether it crosses midnight
        const res = {
            firstDate: title?.format("DD/MM/YYYY"),
            secondDate: endTime.isAfter(midnight) ? endTime.format("DD/MM/YYYY") : null,  // If time crosses midnight
            firstDateHours: firstHour.toFixed(2),  // Hours before midnight (or total hours if no cross)
            secondDateHours: endTime.isAfter(midnight) ? (diffInHours - firstHour).toFixed(2) : null,  // Time after midnight, if applicable
            totalHours: hours.toString().padStart(2, '0') + ":" + minutes.toString().padStart(2, '0'),
            firstHourRaw
        }
    
        return res;
    }
    
    useEffect(()=>{
        if(shiftStartTime?.length>0 && shiftEndTime?.length>0){
            const timeCalculation = calculateTimeDifference(shiftStartTime, shiftEndTime);
            setShiftTime(timeCalculation);
        }
    },[shiftStartTime, shiftEndTime, editDutyId]);

    const dispatch = useDispatch();
    const tenantId = useSelector(state => state?.userAuthReducer?.authenticatedUserDetail?.tenantId);
    const TaskModal = tenantId === "68b3c2e9603397c62fc2d835" ? TaskAssignmentModal : TaskAssignmentModalGeneric;
    const [reportTemplateId, setReportTemplateId] = useState("")

    const [newScheduleOperationTime, {loading: newScheduleTimeLoading}] = useMutation(newScheduleTimesMutation);
    
    // insert check if the employee is assigned here
    const [newScheduleCheck, {loading:newScheduleCheckLoading}] = useMutation(newScheduleCheckMutation);
    const [updateSchedule, {loading: updateScheduleLoading}] = useMutation(updateScheduleMutation);
    const [updateScheduleTimes, {loading: updateScheduleTimesLoading}] = useMutation(updateScheduleTimesMutation);
    const [paySetting, setPaySetting] = useState(null);
    const [billSetting, setBillSetting] = useState(null);
    const [selectedTasks, setSelectedTasks] = useState([]);
    const [selectedCheckpoints, setSelectedCheckpoints] = useState([]);


    // status 
    // open == 0
    // confirm == 1
    // unconfirm Assigned Emp == 2
    // agency allocated == 3

    const [assignNewScheduleTask, {loading: assignNewScheduleTaskLoading}] = useMutation(AssignNewScheduleTaskBulkMutation);

    const [isDutyinCreation, setIsDutyInCreation] = useState(false);

    const handelSubmit = async (isPublished=false)=>{
        try{

            setIsDutyInCreation(true);
            const currentStatus = editDutyData?.getScheduledJobById?.response?.status;
            
            const scheduleInput = {
                // _id: editDutyId,
                branchId: site?.branchDetail?._id,
                customerId: site?.customerDetail?._id,
                siteGroupId: site?.sitegroupDetail?._id,
                siteId: site?._id,
                siteAreaId: area?._id,
                dutyTypeId: dutyType, 
                alarmType:  alarmType,
                hourTypeId: hourType, 
                shiftStartTime: shiftStartTime,
                shiftEndTime: shiftEndTime,
                unPaidBreakDuration: unPaidBreakHour+":"+unPaidBreakMintue,
                unBillBreakDuration: unPaidBillHour+":"+unPaidBillMintue,
                bookingRef, supplierRef,
                assignedEmployee: assignedEmployee?._id || null, 
                assignedAgency: assignedEmployee?._id? null : (assignedAgency || null),
                status: duties > 1 ? "0" :
                currentStatus=="0" ? assignedEmployee? assignedEmployee?._id? "2": currentStatus :
                editDutyData?.getScheduledJobById?.response?.status : assignedAgency? "3" : assignedEmployee? assignedEmployee?._id? "2": "2" :
                "0",

                date: dayjs(title).format("DD/MM/YYYY"),
                shiftEndDateTime: 
                shiftTime?.secondDate? 
                new Date(dayjs(shiftTime?.secondDate+" "+shiftEndTime, "DD/MM/YYYY HH:mm"))
                :
                new Date(dayjs(shiftTime?.firstDate+" "+shiftEndTime, "DD/MM/YYYY HH:mm")),

                firstDate: new Date(dayjs(shiftTime?.firstDate+" "+shiftStartTime, "DD/MM/YYYY HH:mm")),
                secondDate: shiftTime?.secondDate? 
                new Date(dayjs(shiftTime?.secondDate+" "+shiftEndTime, "DD/MM/YYYY HH:mm"))
                : null,
                
                firstDateHours: shiftTime?.firstDateHours,
                secondDateHours: shiftTime?.secondDateHours,

                isPublished: editDutyData?.getScheduledJobById?.response?.isPublished || isPublished,
                reporting: reporting,
                reportTemplateId: reporting? reportTemplateId : null,
                liveLocation,
                paySetting,
                billSetting,
                // No more on/off switch to read - a duty counts as task-assigned
                // whenever at least one task or checkpoint has actually been picked.
                isTaskAssigned: selectedTasks?.length>0 || selectedCheckpoints?.length>0,
                duties,

            };

            if(editDutyId?.length>0){
                scheduleInput['_id'] = editDutyId;
                delete scheduleInput.duties;
                await updateSchedule({
                    variables: {
                        input: scheduleInput
                    }
                });

                if(editDutyId?.length>0){


                    // assign selected tasks and checkpoints

                    if(selectedTasks?.length>0 || selectedCheckpoints?.length>0){
                        const taskAssignment = [
                            ...selectedTasks?.map((task)=>{
                                const {__v, createdAt, tenantId, ...rest} = task;
                                return({ ...rest, scheduleId: editDutyId });
                            }),
                            // ...selectedCheckpoints
                            ...selectedCheckpoints?.map((cp)=>{
                                const {checkpointId, label, associatedSiteGroupLocationId, frequencyType, frequencyValue, from, to, _id} = cp;
                                return({ _id, checkpointId, label, associatedSiteGroupLocationId, frequencyType, frequencyValue, from, to, scheduleId: editDutyId });
                            }),
                        ];

                        try {
                            await assignNewScheduleTask({
                                variables:{
                                    input: taskAssignment
                                }
                            })
                        } catch(taskErr) {
                            console.error("Task/checkpoint assignment failed:", taskErr);
                        }
                    }



                    const operationalTimeInput = {
                        siteId: site?._id,
                        scheduleId: editDutyId,
                        operationalStartDate: new Date(dayjs(shiftTime?.firstDate+" "+shiftStartTime, "DD/MM/YYYY HH:mm")),
                        operationalStartTime:  shiftStartTime,
                        operationalEndDate: shiftTime?.secondDate? 
                        new Date(dayjs(shiftTime?.secondDate+" "+shiftEndTime, "DD/MM/YYYY HH:mm"))
                        : new Date(dayjs(shiftTime?.firstDate+" "+shiftEndTime, "DD/MM/YYYY HH:mm")),
                        operationalEndTime: shiftEndTime,
                        operationalDutyType: dutyType,
                        operationalHourType: hourType,
                        operationalAssignedEmployee: assignedEmployee?._id || null,
                        operationalAssignedAgency: assignedEmployee?._id? null : (assignedAgency || null)
                    };

                   
                    await updateScheduleTimes({
                        variables:{
                            input: operationalTimeInput
                        }
                    })
                
                    if(assignedEmployee){
                        const failureIfAny = failureChecks && Object.keys(failureChecks)?.filter((check)=>failureChecks[check]===true)?.map((check)=> scheduleCheckFailureList[check]?.description);
                        if(failureIfAny?.length>0){
                            await newScheduleCheck({
                                variables:{
                                    input:{
                                        scheduleId: editDutyId,
                                        employeeId: assignedEmployee?._id,
                                        check: failureIfAny,
                                        date: dayjs(),
                                    }
                                }
                            });
                        }
                    }
    
                }

            }
            else{
                
                const newScheduleResponse = await newSchedule({
                    variables:{
                        // creationSource: for the duty's audit trail (Origin)
                        input: {...scheduleInput, creationSource: "form"}
                    }
                });

                // assign selected tasks and checkpoints

                if((selectedTasks?.length>0 || selectedCheckpoints?.length>0) && duties==1 ){
                    
                    const taskAssignment = [
                        ...selectedTasks?.map((task)=>{
                            const {tenantId, ...rest} = task;
                            return({ ...rest, scheduleId: newScheduleResponse?.data?.newSchedule?.response?._id });
                        }),
                        ...selectedCheckpoints?.map((cp)=>{
                            const {checkpointId, label, associatedSiteGroupLocationId, frequencyType, frequencyValue, from, to} = cp;
                            return({ checkpointId, label, associatedSiteGroupLocationId, frequencyType, frequencyValue, from, to, scheduleId: newScheduleResponse?.data?.newSchedule?.response?._id });
                        }),
                    ];

                    try {
                        await assignNewScheduleTask({
                            variables:{
                                input: taskAssignment
                            }
                        })
                    } catch(taskErr) {
                        // e.g. a checkpoint's NFC tag wasn't configured yet (the picker
                        // modal already blocks selecting one, but its data could still go
                        // stale between opening the picker and hitting Save here) - the
                        // duty itself is still created, but its task/checkpoint patrol
                        // wasn't, so this has to reach the user, not just the console.
                        console.error("Task/checkpoint assignment failed:", taskErr);
                        dispatch(setNotification({ error: true, notificationState: true, message: taskErr.message }));
                    }
                }else if((selectedTasks?.length>0 || selectedCheckpoints?.length>0) && duties>1 ){
                    
                    const taskAssignment = [
                        ...selectedTasks?.map((task)=>{
                            const {tenantId, ...rest} = task;
                            return({ ...rest });
                        }),
                        ...selectedCheckpoints?.map((cp)=>{
                            const {checkpointId, label, associatedSiteGroupLocationId, frequencyType, frequencyValue, from, to} = cp;
                            return({ checkpointId, label, associatedSiteGroupLocationId, frequencyType, frequencyValue, from, to});
                        }),
                    ];

                    const task = newScheduleResponse?.data?.newSchedule?.response?.schedule?.map((sc)=>{
                        return taskAssignment?.map((task)=>{
                            return {
                                ...task,
                                scheduleId: sc
                            }
                        })
                    }).flat()
                   
                    try {

                        await assignNewScheduleTask({
                            variables:{
                                input: task
                            }
                        })

                    } catch(taskErr) {
                        console.error("Task/checkpoint assignment failed:", taskErr);
                        dispatch(setNotification({ error: true, notificationState: true, message: taskErr.message }));
                    }
                }

                if(assignedEmployee?._id && newScheduleResponse?.data?.newSchedule?.response?._id){
                    const operationalTimeInput = {
                        siteId: site?._id,
                        scheduleId: newScheduleResponse?.data?.newSchedule?.response?._id,
                        operationalStartDate: new Date(dayjs(shiftTime?.firstDate+" "+shiftStartTime, "DD/MM/YYYY HH:mm")),
                        operationalStartTime:  shiftStartTime,
                        operationalEndDate: shiftTime?.secondDate? 
                        new Date(dayjs(shiftTime?.secondDate+" "+shiftEndTime, "DD/MM/YYYY HH:mm"))
                        : new Date(dayjs(shiftTime?.firstDate+" "+shiftEndTime, "DD/MM/YYYY HH:mm")),
                        operationalEndTime: shiftEndTime,
                        operationalDutyType: dutyType,
                        operationalHourType: hourType,
                        operationalAssignedEmployee: assignedEmployee?._id,
                        operationalAssignedAgency: assignedEmployee?._id? null : assignedAgency,
                        isOperationalSaved: false
                    };
                    try{

                        await newScheduleOperationTime({
                            variables:{
                                input: operationalTimeInput
                            }
                        });
                    }catch(err){
                        dispatch(setNotification({
                            error: true,
                            notificationState: true,
                            message: "Error encountered while creating the calls, please delete this duty and create new one",
                        }))
                    }

                    try{
        
                        const failureIfAny = failureChecks && Object.keys(failureChecks)?.filter((check)=>failureChecks[check]===true)?.map((check)=> scheduleCheckFailureList[check]?.description);
                        
                        if(failureIfAny?.length>0){
                            await newScheduleCheck({
                                variables:{
                                    input:{
                                        scheduleId: newScheduleResponse?.data?.newSchedule?.response?._id,
                                        employeeId: assignedEmployee?._id,
                                        check: failureIfAny,
                                        date: dayjs(),
                                    }
                                }
                            });
                        }

                    }catch(err){
                        dispatch(setNotification({
                            error: true,
                            notificationState: true,
                            message: "Error encountered while creating the check failures",
                        }));

                    }
    
                }
                
            }

            dispatch(setNotification({
                error: false,
                notificationState: true,
                message: "Job Scheduled!",
            }));

            close();
            await scheduleRefetch();
            setFailureChecks(null);
            
        }catch(err){
            
            dispatch(setNotification({
                error: true,
                notificationState: true,
                message: err.message
            }))
            close();
            await scheduleRefetch();

        }finally{
            setIsDutyInCreation(false);
        }
    };

    const searchRef = useRef(null);
    const searchSegmentRef= useRef(null);
    const searchDetailSegmentRef = useRef(null);

    const handleClickOutside = (event) => {
       
        if (searchSegmentRef?.current instanceof HTMLElement && !searchSegmentRef.current.contains(event.target) &&
            !Array.from(event.target.classList).find(cls => cls.includes('ant-select-item-option-content') || cls.includes('ant-select-item') ) &&
            searchDetailSegmentRef?.current instanceof HTMLElement && !searchDetailSegmentRef.current.contains(event.target)
        )
        {
            setSearchPopup(false);
            setSearch("");
        }
    };


    React.useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [searchSegmentRef, searchDetailSegmentRef]);

    const [reporting, setReporting] = useState(false);
    const [assignTaskModal, setAssignTaskModal] = useState(false);
    // Which internal tab (tasks/checkpoints) the assignment modal opens on - set right
    // before opening, based on which of the two links below was clicked.
    const [taskModalInitialTab, setTaskModalInitialTab] = useState('tasks');
    const [liveLocation, setLiveLocation] = useState(false);

    const {data: standardTemplateData, loading: standardTemplateLoading} = useQuery(getReportTemplates,{
        variables: {
            customerId: null,
            isArchived: false
        },
        fetchPolicy: 'network-only'
    });

    const {data: customerTemplateData, loading: customerTemplateLoading} = useQuery(getReportTemplates,{
        variables: {
            customerId: site?.customerDetail?._id,
            isArchived: false
        },
        fetchPolicy: 'network-only'
    });

    const [standardTemplates, setStandardTemplates] = useState([]);
    const [customerTemplates, setCustomerTemplates] = useState([]);

    useEffect(()=>{
        if(standardTemplateData?.getReportTemplates?.response?.length){
            setStandardTemplates(standardTemplateData?.getReportTemplates?.response);
        }
        if(customerTemplateData?.getReportTemplates?.response?.length){
            setCustomerTemplates(customerTemplateData?.getReportTemplates?.response);
        }
    },[standardTemplateData?.getReportTemplates?.response, customerTemplateData?.getReportTemplates?.response]);


    const [checkFailVisible, setCheckFailVisible] = useState(false);

// set checks to render in modal
    const [failureChecks, setFailureChecks] = useState(null);
    useEffect(()=>{
        setFailureChecks(null);
        ()=>{
            setFailureChecks(null);
        }
    },[]);


    // get employee on search to assign and 
    const [getEmployeeOnSearch, {data: empSearchData, loading: empSearchDataLoading, refetch} ]= useLazyQuery(getEmployeeForScheduleSearchQuery);
    
    const [scheduleStartDate, setScheduleStartDate] = useState(null);
    const [scheduleEndDate, setScheduleEndDate] = useState(null);
    
    const [assignAgencyLocally, setAssignAgencyLocally] = useState(null);
    
    // get employee based on agency
    const { data: agencyEmployee, loading: agencyEmployeeLoading } = useQuery(getEmployeeForScheduleSearchQuery,{
        variables: {
            input: {
                filters:  {advanceFilter: [[{
                    filter: "contain_exactly",
                    filterValue: [assignAgencyLocally],
                    operator: 'Agency'
                }]]},
                schedule: {startDate:scheduleStartDate, endDate:scheduleEndDate}
            }
        },
        fetchPolicy: 'network-only',
        skip: scheduleStartDate==null || scheduleEndDate==null || assignAgencyLocally?.length<1
    });
    
    const [activeAssociatedModule, setActiveAssociateModule] = useState("employee");


    const [EmployeeSearchResult, setEmpSearchResult] = useState([]);

    // ===== create new employee inline from the association popover =====
    const apolloClient = useApolloClient();

    const [newEmployeeModal, setNewEmployeeModal] = useState(false);
    const [newEmployeeSchema, setNewEmployeeSchema] = useState();
    const [newEmployeeData, setNewEmployeeData] = useState([]);
    const [newEmployeeBtnEnable, setNewEmployeeBtnEnable] = useState(true);
    const [newEmployeeOverlay, setNewEmployeeOverlay] = useState(true);

    const {data: newEmployeeObject, loading: newEmployeeObjectLoading, refetch: newEmployeeObjectRefetch} = useQuery(EmployeeObjectQuery,{
        fetchPolicy: 'cache-and-network',
        skip: !newEmployeeModal
    });

    useEffect(()=>{
        if(!newEmployeeObjectLoading){
            setNewEmployeeSchema(newEmployeeObject?.getEmployeeObject?.response?.filter((dataField)=>dataField.propertyDetail?.fieldType!=="agency"));
        }
    },[newEmployeeObjectLoading]);

    const [addNewEmployeeMutation, {loading: newEmployeeProcessLoading}] = useMutation(AddEmployeeMutation);
    const [restoreNewEmployeeMutation] = useMutation(RestoreEmployeeMutation);

    const newEmployeeMutation = async (employee)=>{
        try{
            const { data: duplicateCheckData } = await apolloClient.query({
                query: CheckEmployeeDuplicateQuery,
                variables: { input: { firstname: employee?.firstname, lastname: employee?.lastname, email: employee?.metadata?.email } },
                fetchPolicy: 'network-only',
            });

            const duplicate = duplicateCheckData?.checkEmployeeDuplicate?.response;

            if(duplicate?.exists){
                if(duplicate?.isArchived && duplicate?.sameTenant){
                    const confirmResult = await Swal.fire({
                        icon: 'warning',
                        title: 'Employee Already Exists',
                        html: `An archived employee record matches <b>${duplicate?.employee?.firstname} ${duplicate?.employee?.lastname}</b>${duplicate?.employee?.metadata?.email? ` (${duplicate?.employee?.metadata?.email})` : ''}. Would you like to restore it instead of creating a new one?`,
                        showCancelButton: true,
                        confirmButtonText: 'Restore',
                        cancelButtonText: 'Cancel',
                    });

                    if(confirmResult?.isConfirmed){
                        await restoreNewEmployeeMutation({variables: {employeeId: duplicate?.employee?._id}});
                        dispatch(setNotification({
                            notificationState:true,
                            message: "Employee restored successfully",
                            error: false,
                        }));
                        setNewEmployeeData([]);
                        setNewEmployeeBtnEnable(true);
                        setNewEmployeeOverlay(true);
                        setSearch(`${employee?.firstname}`);
                        setActiveAssociateModule("employee");
                        setSearchPopup(true);
                        return true;
                    }

                    return false;
                }

                dispatch(setNotification({
                    message: duplicateCheckData?.checkEmployeeDuplicate?.message,
                    error: true,
                    notificationState: true
                }));
                return false;
            }

            await addNewEmployeeMutation({variables: {input: employee}});
            dispatch(setNotification({
                notificationState:true,
                message: "Employee was added successfully",
                error: false,
            }));
            setNewEmployeeData([]);
            setNewEmployeeBtnEnable(true);
            setNewEmployeeOverlay(true);
            setSearch(`${employee?.firstname}`);
            setActiveAssociateModule("employee");
            setSearchPopup(true);

            return true;
        }
        catch(err){
            dispatch(setNotification({
                message: err?.message,
                error: true,
                notificationState: true
            }));
            return false;
        }
    };

    const handelNewEmployeeSubmit = async (isCloseAble)=>{
        const firstname = newEmployeeData?.find((d)=>(Object.keys(d)[0]=="firstname"));
        const lastname = newEmployeeData?.find((d)=>(Object.keys(d)[0]==="lastname"));
        const branch = newEmployeeData?.find((d)=>(Object.keys(d)[0]==="branch"));

        let metadata = {};
        newEmployeeData?.map(d=>{
            if(Object.keys(d)[0]!=="firstname" && Object.keys(d)[0]!=="lastname" && Object.keys(d)[0]!=="branch"){
                metadata[Object.keys(d)[0]]= Object.values(d)[0]
            }
        });
        const employee = {
            ...firstname,
            ...lastname,
            branch: [...(branch?.branch || [])],
            metadata,
        }

        const success = await newEmployeeMutation(employee);

        if(isCloseAble && success){
            setNewEmployeeModal(false);
        }
    };


    const [bankHoliday, setBankHoliday] = useState([]);
    const {data: holidayData, loading: holidayLoading} = useQuery(getSystemHolidayQuery);


    const [todayBankHoliday, setTodayBankHoliday] = useState(null);
  

    useEffect(()=>{
        if(holidayData?.getSystemHoliday && !holidayLoading){
            setTodayBankHoliday(null);
            setBankHoliday(holidayData?.getSystemHoliday?.holiday);
        }
    },[holidayData, holidayLoading]);

    useEffect(()=>{
        const isTodayBankHoliday = bankHoliday?.find((bh)=>dayjs(bh?.date).format("DD/MM/YYYY")==dayjs(title).format("DD/MM/YYYY"));
        setTodayBankHoliday(isTodayBankHoliday);
    },[bankHoliday]);

    

    const [searchPopup, setSearchPopup] = useState(false);

    const {data: agencyData, loading: agencyLoading} = useQuery(getAgencies,{
        fetchPolicy: 'network-only',
        variables: {
            input: {
                filters: null
            }
        },
    });

     
    useEffect(()=>{
        if(shiftStartTime && shiftEndTime && shiftTime){
            const endDate = 
                shiftTime?.secondDate? 
                dayjs(shiftTime?.secondDate+" "+shiftEndTime, "DD/MM/YYYY HH:mm")
                :
                dayjs(shiftTime?.firstDate+" "+shiftEndTime, "DD/MM/YYYY HH:mm");

            const startDate = dayjs(shiftTime?.firstDate+" "+shiftStartTime, "DD/MM/YYYY HH:mm");
           
            
            setScheduleStartDate(startDate);
            setScheduleEndDate(endDate);
            
        }

        if(activeAssociatedModule=="employee" && debouncedSearch?.length>0){
            
            getEmployeeOnSearch({fetchPolicy: 'cache-and-network',
                variables: {
                    input: {
                        filters:  {
                            advanceFilter: [
                                [{
                                    operator: "First name", condition:'and', filter: "contain_exactly", filterValue: [debouncedSearch]
                                }],

                                [{
                                    operator: "Last name", condition: "or", filter: "contain_exactly", filterValue: [debouncedSearch]
                                }]
                            ]
                        },
                        schedule: {}
                    }
                },
                fetchPolicy: 'cache-and-network',
            });

            setEmpSearchResult(empSearchData?.getEmployeeForScheduleSearch?.response);

        }else{
            setEmpSearchResult(empSearchData?.getEmployeeForScheduleSearch?.response);
        }
    
        
    },[debouncedSearch, activeAssociatedModule, shiftStartTime, shiftEndTime, shiftTime]);
    
    
    useEffect(()=>{
        if(activeAssociatedModule=="employee" && !empSearchDataLoading && empSearchData?.getEmployeeForScheduleSearch?.response){
            setEmpSearchResult(empSearchData?.getEmployeeForScheduleSearch?.response);
        }
    },[activeAssociatedModule, search, empSearchData?.getEmployeeForScheduleSearch?.response, empSearchDataLoading]);
   
   
    useEffect(()=>{
        setSearch("");
    },[activeAssociatedModule]);


//=========================== handel edit duty ===================================
    useEffect(()=>{
        if(editDutyData?.getScheduledJobById?.response && editDutyId && !editDutyDataLoading){
            const editDutyDetail = editDutyData?.getScheduledJobById?.response;
            setDutyType(editDutyDetail?.dutyTypeId);
            setHourType(editDutyDetail?.hourTypeId);
            setShiftStartTime(editDutyDetail?.shiftStartTime);
            setShiftEndTime(editDutyDetail?.shiftEndTime);
            
            // handles "H:MM" and older plain-minutes values ("30") saved from the Breaks tab
            const unBillBreak = splitBreakDuration(editDutyDetail?.unBillBreakDuration);
            setUnPaidBillHour(unBillBreak.hour);
            setUnPaidBillMintue(unBillBreak.minute);

            const unPaidBreak = splitBreakDuration(editDutyDetail?.unPaidBreakDuration);
            setUnPaidBreakHour(unPaidBreak.hour);
            setUnPaidBreakMintue(unPaidBreak.minute);
            
            setBookingRef(editDutyDetail?.bookingRef);
            setSupplierRef(editDutyDetail?.supplierRef);
            setReporting(editDutyDetail?.reporting);
            setReportTemplateId(editDutyDetail?.reportTemplateId);

            
            setAssignedAgency(editDutyDetail?.assignedAgency);
            setEmployeeSlider(true);
            if(editDutyDetail?.assignedEmployeeDetail){

                setAssignedEmployee({emp: editDutyDetail?.assignedEmployeeDetail, _id: editDutyDetail?.assignedEmployee, isFromSearch: true})
            }
            setSelectedTasks(editDutyDetail?.assignedTasks?.filter((task)=> !task?.checkpointId));
            setSelectedCheckpoints(editDutyDetail?.assignedTasks?.filter((task)=> task?.checkpointId))
            setLiveLocation(editDutyDetail?.liveLocation);
            setPaySetting(editDutyDetail?.paySetting);
            setBillSetting(editDutyDetail?.billSetting)
            
        }
    },[editDutyData?.getScheduledJobById?.response, visible, editDutyDataLoading, editDutyId]);


    const [scheduleAssistantVisible, setScheduleAssistantVisible] = useState(false);

    const [reportingStatus, setReportingStatus] = useState(false);
    useEffect(()=>{
        if(reporting){
            setReportingStatus(true);
            if(reportTemplateId?.length>0){
                setReportingStatus(false);
            }
            
        }else{
            setReportingStatus(false);
        }
    },[reporting, reportTemplateId]);

    // {
    //     dutyType=="65ff5f97cdef94de7cabc3ef" &&
    //     <tr>
    //         <td> <label>Alarm Type</label></td>
    //         <td>
    //             <Select
    //                 showSearch
    //                 optionFilterProp="children"
    //                 style={{width:'-webkit-fill-available'}}
    //                 value={alarmType}
    //                 className="custom-select"
    //                 suffixIcon={<div className="dropdowncaret"></div>}
    //                 placeholder="Select alarm type  "
    //                 onChange={(e)=>setAlarmType(e)}
    //             >
                    
    //                 <Option value={"FA"}>Fire alarm activation</Option>
    //                 <Option value={"IA"}>Intruder alarm activation</Option>

    //             </Select>
    //         </td>
    //     </tr>
    // } 

    return(
        <>
            <Modal
                open={visible}
                width={employeeSlider?'60%':'40%'}
                style={{top:10, overflow:'auto'}}
                footer={
                    <div className="drawer-footer" style={{padding:'26px 40px', textAlign:'left', display:'flex', columnGap:'16px', marginTop:'-25px' }}>
                        <button  
                            onClick={()=>handelSubmit()}
                            disabled={(isDutyinCreation || (!employeeSlider && duties==1) || shiftEndTime?.length==0 || reportingStatus || newScheduleLoading || newScheduleTimeLoading || newScheduleCheckLoading || updateScheduleLoading || updateScheduleTimesLoading)} 
                            className={(isDutyinCreation || ((!employeeSlider  && duties==1) || shiftEndTime?.length==0) || reportingStatus || newScheduleLoading || newScheduleTimeLoading || newScheduleCheckLoading || updateScheduleLoading || updateScheduleTimesLoading)? 'disabled-btn drawer-filled-btn' : 'drawer-filled-btn'} 
                        >
                            {(isDutyinCreation || newScheduleLoading || newScheduleTimeLoading || newScheduleCheckLoading || updateScheduleLoading || updateScheduleTimesLoading)? <Spin indicator={<LoadingOutlined/>}/> : "Save"}
                        </button>
                        <button  
                            onClick={()=>handelSubmit(true)}
                            disabled={isDutyinCreation || !assignedEmployee || !employeeSlider || shiftEndTime?.length==0 || editDutyData?.getScheduledJobById?.response || reportingStatus || newScheduleLoading || newScheduleTimeLoading || newScheduleCheckLoading || updateScheduleLoading || updateScheduleTimesLoading} 
                            className={isDutyinCreation || !assignedEmployee || !employeeSlider || shiftEndTime?.length==0 || editDutyData?.getScheduledJobById?.response || reportingStatus || newScheduleLoading || newScheduleTimeLoading || newScheduleCheckLoading || updateScheduleLoading || updateScheduleTimesLoading? 'disabled-btn drawer-filled-btn' : 'drawer-filled-btn'} 
                        >
                            {newScheduleLoading || newScheduleTimeLoading || newScheduleCheckLoading || updateScheduleLoading || updateScheduleTimesLoading? <Spin indicator={<LoadingOutlined/>}/> : "Save & publish"}
                        </button>
                        <button  disabled={isDutyinCreation|| newScheduleLoading || newScheduleTimeLoading || newScheduleCheckLoading || updateScheduleLoading || updateScheduleTimesLoading} className={isDutyinCreation|| newScheduleLoading || newScheduleTimeLoading || newScheduleCheckLoading || updateScheduleLoading || updateScheduleTimesLoading? 'disabled-btn drawer-outlined-btn':'drawer-outlined-btn'} onClick={close}>
                            Cancel
                        </button>
                    </div>
                }
                closable={false}
            >
                <React.Fragment>

                    <div className='modal-header-title'>
                        <span>
                            {dayjs(title)?.format("ddd, MMM") +" "+ dayjs(title)?.format("DD")} - {site?.sitename} - {area?.areaname} &nbsp;<HelpLink slug="ops-adding-duties" />
                            <br/>
                            {todayBankHoliday?
                                <small style={{color:'white', fontSize:'14px'}}>BANK HOLIDAY - {todayBankHoliday?.title}</small>
                                :
                                null
                            }
                        </span>
                        <span  onClick={close}><FontAwesomeIcon className='close' icon={faClose}/></span>
                    </div>

                    {editDutyId?.length>0 && editDutyDataLoading?
                        <div className='modal-body' style={{display:'flex', justifyContent:'center', alignItems:'center', margin:'50px 0'}}>
                            <Spinner />
                        </div>
                    :
                        <div className='modal-body'>

                            <div className="duty-modal-head">

                                    <div>
                                        <span> <FontAwesomeIcon icon={faPersonBooth}/> Area</span>
                                        <div>{area?.areaname}</div>
                                    </div>

                                    <div>
                                        <span><FontAwesomeIcon icon={faStreetView}/> Site</span>
                                        <div>{site?.sitename}</div>
                                    </div>

                                    <div>
                                        <span><FontAwesomeIcon icon={faPersonDigging} /> Site Service</span>
                                        <div>{site?.metadata?.servicestype}</div>
                                    </div>

                                    <div>
                                        <span><FontAwesomeIcon icon={faLayerGroup} /> Site group</span>
                                        <div>{site?.sitegroupDetail?.sitegroupname}</div>
                                    </div>

                                    <div>
                                        <span><FontAwesomeIcon icon={faPersonBurst} /> Customer</span>
                                        <div>{site?.customerDetail?.customername}</div>
                                    </div>

                                    <div>
                                        <span><FontAwesomeIcon icon={faClockRotateLeft}/> Shift time</span>
                                        <div>{Object.keys(shiftTime)?.length>0? shiftTime?.totalHours : "00:00"}</div>
                                    </div>

                            </div>
                            
                            
                            <div style={{ 
                                display: 'flex', 
                                gap: '20px', 
                                boxSizing: 'border-box'
                            }}>

                                <div className="dutyForm" style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', padding: '0 8px' }}>
                                    
                                    {/* Duty Type and Hour Type - Duty Type takes the full row while Hour Type is hidden */}
                                    <div style={{ display: 'grid', gridTemplateColumns: SHOW_HOUR_TYPE ? '1fr 1fr' : '1fr', gap: '16px', marginBottom: '12px' }}>
                                        <div>
                                        <label style={{ display: 'block', marginBottom: '2px', fontSize: '13px' }}>Duty Type</label>
                                        <Select
                                            showSearch
                                            optionFilterProp="children"
                                            style={{ width: '100%' }}
                                            loading={dutyTypeLoading}
                                            disabled={dutyTypeLoading}
                                            className="custom-select"
                                            suffixIcon={<div className="dropdowncaret"></div>}
                                            placeholder="Select duty type"
                                            onChange={(e) => setDutyType(e)}
                                            value={dutyType}
                                        >
                                            {/* guarding types at a customer site, every type at an internal site */}
                                            {dutyTypesForSite(dutyTypeData?.getPayLevel?.response, site, dutyType)?.map((dutyTypeData) => (
                                            <Option value={dutyTypeData?._id}>{dutyTypeData?.name}</Option>
                                            ))}
                                        </Select>
                                        </div>

                                        {SHOW_HOUR_TYPE &&
                                        <div>
                                        <label style={{ display: 'block', marginBottom: '2px', fontSize: '13px' }}>Hour Type</label>
                                        <Select
                                            showSearch
                                            style={{ width: '100%' }}
                                            optionFilterProp="children"
                                            loading={hourTypeDataLoading}
                                            disabled={hourTypeDataLoading}
                                            className="custom-select"
                                            suffixIcon={<div className="dropdowncaret"></div>}
                                            placeholder="Select hour type"
                                            onChange={(e) => setHourType(e)}
                                            value={hourType}
                                        >
                                            {hourTypeData?.getShiftType?.response?.map((hour) => (
                                            <Option value={hour?._id}>{hour?.name}</Option>
                                            ))}
                                        </Select>
                                        </div>
                                        }
                                    </div>

                                    {/* Shift Start Time and Shift End Time */}
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', }}>
                                        <div>
                                        <label style={{ display: 'block', marginBottom: '2px', fontSize: '13px' }}>Shift Start Time</label>
                                        <Form.Item style={{ margin: 0 }}>
                                            <TimeTextInput
                                                className="generic-input-control"
                                                style={{ height: '20px', width: '100%' }}
                                                onChange={setShiftStartTime}
                                                value={shiftStartTime}
                                            />
                                        </Form.Item>
                                        </div>

                                        <div>
                                        <label style={{ display: 'block', marginBottom: '2px', fontSize: '13px' }}>Shift End Time</label>
                                        <Form.Item style={{ margin: 0 }}>
                                            <TimeTextInput
                                                className="generic-input-control"
                                                style={{ height: '20px', width: '100%' }}
                                                onChange={setShiftEndTime}
                                                value={shiftEndTime}
                                            />
                                        </Form.Item>
                                        </div>
                                    </div>

                                    {/* Unpaid Break Duration and Unbill Break Duration */}
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px',  }}>
                                        <div>
                                        <label style={{ display: 'block', marginBottom: '2px', fontSize: '13px' }}>UnPaid Break Duration</label>
                                        <div style={{ display: 'flex', gap: '12px' }}>
                                            <Form.Item className="numberInput" style={{ margin: '0', flex: 1 }}>
                                            <InputNumber
                                                placeholder="HH"
                                                min={0}
                                                max={3}
                                                precision={0}
                                                onKeyDown={blockNonIntegerKeys}
                                                onChange={(e) => setUnPaidBreakHour(e)}
                                                value={unPaidBreakHour}
                                                className="generic-input-control"
                                                style={{ width: '100%' }}
                                                upHandler={<FontAwesomeIcon style={{ color: '#0091ae' }} icon={faChevronUp} />}
                                                downHandler={<FontAwesomeIcon style={0 > 1 && { color: '#0091ae' }} icon={faChevronDown} />}
                                            />
                                            </Form.Item>
                                            <Form.Item className="numberInput" style={{ margin: '0', flex: 1 }}>
                                            <InputNumber
                                                placeholder="MM"
                                                min={0}
                                                max={59}
                                                precision={0}
                                                onKeyDown={blockNonIntegerKeys}
                                                className="generic-input-control"
                                                style={{ width: '100%' }}
                                                value={unPaidBreakMintue}
                                                onChange={(e) => setUnPaidBreakMintue(e)}
                                                upHandler={<FontAwesomeIcon style={{ color: '#0091ae' }} icon={faChevronUp} />}
                                                downHandler={<FontAwesomeIcon style={0 > 1 && { color: '#0091ae' }} icon={faChevronDown} />}
                                            />
                                            </Form.Item>
                                        </div>
                                        </div>

                                        <div>
                                        <label style={{ display: 'block', marginBottom: '2px', fontSize: '13px' }}>UnBill Break Duration</label>
                                        <div style={{ display: 'flex', gap: '12px' }}>
                                            <Form.Item className="numberInput" style={{ margin: '0', flex: 1 }}>
                                            <InputNumber
                                                placeholder="HH"
                                                min={0}
                                                max={3}
                                                precision={0}
                                                onKeyDown={blockNonIntegerKeys}
                                                onChange={(e) => setUnPaidBillHour(e)}
                                                value={unPaidBillHour}
                                                className="generic-input-control"
                                                style={{ width: '100%' }}
                                                upHandler={<FontAwesomeIcon style={{ color: '#0091ae' }} icon={faChevronUp} />}
                                                downHandler={<FontAwesomeIcon style={0 > 1 && { color: '#0091ae' }} icon={faChevronDown} />}
                                            />
                                            </Form.Item>
                                            <Form.Item className="numberInput" style={{ margin: '0', flex: 1 }}>
                                            <InputNumber
                                                placeholder="MM"
                                                min={0}
                                                max={59}
                                                precision={0}
                                                onKeyDown={blockNonIntegerKeys}
                                                onChange={(e) => setUnPaidBillMintue(e)}
                                                value={unPaidBillMintue}
                                                className="generic-input-control"
                                                style={{ width: '100%' }}
                                                upHandler={<FontAwesomeIcon style={{ color: '#0091ae' }} icon={faChevronUp} />}
                                                downHandler={<FontAwesomeIcon style={0 > 1 && { color: '#0091ae' }} icon={faChevronDown} />}
                                            />
                                            </Form.Item>
                                        </div>
                                        </div>
                                    </div>

                                    {/* Pay Setting and Bill Setting */}
                                    {/* <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '12px' }}>
                                        <div>
                                        <label style={{ display: 'block', marginBottom: '2px', fontSize: '13px' }}>Pay Setting</label>
                                        <Select
                                            className="custom-select"
                                            placeholder="Select Pay Type"
                                            suffixIcon={<div className="dropdowncaret"></div>}
                                            style={{ width: '100%' }}
                                            onChange={(e) => setPaySetting(e)}
                                            value={paySetting}
                                        >
                                            <Option value="task">Pay - Task Base</Option>
                                            <Option value="time">Pay - Schedule Time</Option>
                                        </Select>
                                        </div>

                                        <div>
                                        <label style={{ display: 'block', marginBottom: '2px', fontSize: '13px' }}>Bill Setting</label>
                                        <Select
                                            className="custom-select"
                                            placeholder="Select Bill Type"
                                            suffixIcon={<div className="dropdowncaret"></div>}
                                            style={{ width: '100%' }}
                                            onChange={(e) => setBillSetting(e)}
                                            value={billSetting}
                                        >
                                            <Option value="task">Bill - Task Base</Option>
                                            <Option value="time">Bill - Schedule Time</Option>
                                        </Select>
                                        </div>
                                    </div> */}

                                    {/* Reporting - commented out for now, per request. reporting/reportTemplateId
                                        state and the save payload are untouched (reporting stays false, so the
                                        report-template validation below never blocks Save); uncomment to restore.
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '12px' }}>
                                        <div>
                                        <label style={{ display: 'block', marginBottom: '2px', fontSize: '13px' }}>Reporting</label>
                                        <div style={{ display: 'flex', gap: '12px', alignItems: 'center'}}>
                                            <Select
                                                className="custom-select"
                                                style={{ width: '100%' }}
                                                suffixIcon={<div className="dropdowncaret"></div>}
                                                onChange={(e)=>setReporting(e)}
                                                value={reporting}
                                            >
                                                <Option value={true}>Yes</Option>
                                                <Option value={false}>No</Option>
                                            </Select>

                                            {reporting ? (
                                            <Form.Item
                                                validateStatus={reportingStatus ? "error" : null}
                                                help={reportingStatus ? <div className="mt16" style={{ position: 'absolute' }}>Please select report template</div> : null}
                                                style={{ width: '100%', marginBottom: '26px' }}
                                            >
                                                <Select
                                                style={{ width: '100%' }}
                                                showSearch
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    (option?.label?.props?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                                }
                                                className="custom-select"
                                                suffixIcon={<div className="dropdowncaret"></div>}
                                                onChange={(e) => setReportTemplateId(e)}
                                                value={reportTemplateId}
                                                placeholder={"Select report template"}
                                                options={[
                                                    {
                                                    label: <span style={{ color: 'rgba(0, 0, 0, 0.45)' }}>Custom Templates</span>,
                                                    title: 'Custom template',
                                                    options: customerTemplates?.map((templates) => ({ label: templates?.templatename, value: templates?._id }))
                                                    },
                                                    {
                                                    label: <span style={{ color: 'rgba(0, 0, 0, 0.45)' }}>Standard Templates</span>,
                                                    title: 'Standard template',
                                                    options: standardTemplates?.map((templates) => ({ label: templates?.templatename, value: templates?._id }))
                                                    }
                                                ]}
                                                />
                                            </Form.Item>
                                            ) : null}
                                        </div>
                                        </div>
                                        <!-- Number of duties used to live here, as the second half of this grid row -->
                                    </div>
                                    */}

                                    {/* Number of duties (new duties only) pairs with Live Location - both are
                                        duty-mechanics fields, Live Location as a Yes/No dropdown like the other
                                        Select fields on this form rather than a switch. Task and Checkpoint get
                                        their own row right below, each keeping its own label above its button -
                                        they used to be mixed in with these unrelated fields one-per-row. Task/
                                        Checkpoint have no gating switch anymore: independent buttons, each opening
                                        the assignment drawer directly on its own tab. A duty counts as task-assigned
                                        automatically once either one actually has something picked (see
                                        isTaskAssigned in handelSubmit). The "Number of duties" cell renders an
                                        empty <div/> rather than null when editing, so the grid always has two
                                        children and Live Location doesn't shift into column 1. */}
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '12px' }}>
                                        {
                                            editDutyId?.length>0? <div/> :

                                            <div>
                                                <label style={{ display: 'block', marginBottom: '2px', fontSize: '13px' }}>Number of duties</label>
                                                <Form.Item className="numberInput" style={{ margin: '0', width:'100%' }}>
                                                    <InputNumber
                                                        placeholder="Number of duties"
                                                        min={1}
                                                        max={150}
                                                        onChange={(value) => {
                                                            if (value === null || value < 1) {
                                                                setDuties(1);
                                                            } else if (value > 150) {
                                                                setDuties(150);
                                                            } else {
                                                                setDuties(value);
                                                            }
                                                        }}
                                                        value={duties}
                                                        className="generic-input-control"
                                                        style={{ width: '100%' }}
                                                        upHandler={<FontAwesomeIcon style={{ color: '#0091ae' }} icon={faChevronUp} />}
                                                        downHandler={<FontAwesomeIcon style={0 > 1 && { color: '#0091ae' }} icon={faChevronDown} />}
                                                    />
                                                </Form.Item>
                                            </div>
                                        }

                                        <div>
                                            <label style={{ display: 'block', marginBottom: '2px', fontSize: '13px' }}>Live Location</label>
                                            <Select
                                                className="custom-select"
                                                style={{ width: '100%' }}
                                                suffixIcon={<div className="dropdowncaret"></div>}
                                                onChange={(e) => setLiveLocation(e)}
                                                value={liveLocation}
                                            >
                                                <Option value={true}>Yes</Option>
                                                <Option value={false}>No</Option>
                                            </Select>
                                        </div>
                                    </div>

                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '12px' }}>
                                        <div>
                                            <label style={{ display: 'block', marginBottom: '2px', fontSize: '13px' }}>Task</label>
                                            <button
                                                type="button"
                                                className="drawer-outlined-btn"
                                                style={{ padding: '8px 16px', width: '100%' }}
                                                onClick={() => { setTaskModalInitialTab('tasks'); setAssignTaskModal(true); }}
                                            >
                                                {selectedTasks?.length>0? `${selectedTasks.length} Task${selectedTasks.length>1?'s':''}` : "Assign Task"} <FontAwesomeIcon icon={faExternalLink} style={{marginLeft:6}}/>
                                            </button>
                                        </div>

                                        <div>
                                            <label style={{ display: 'block', marginBottom: '2px', fontSize: '13px' }}>Checkpoint</label>
                                            <button
                                                type="button"
                                                className="drawer-outlined-btn"
                                                style={{ padding: '8px 16px', width: '100%' }}
                                                onClick={() => { setTaskModalInitialTab('checkpoints'); setAssignTaskModal(true); }}
                                            >
                                                {selectedCheckpoints?.length>0? `${selectedCheckpoints.length} Checkpoint${selectedCheckpoints.length>1?'s':''}` : "Assign Checkpoint"} <FontAwesomeIcon icon={faExternalLink} style={{marginLeft:6}}/>
                                            </button>
                                        </div>
                                    </div>

                                    
                                </div>

                                {employeeSlider && (
                                    <div className={employeeSlider ? "emplist" : ""} style={{ width: '350px', display: 'flex', flexDirection: 'column', overflow: 'hidden', height: '100%' }}>
                                    {assignedEmployee?.isFromSearch && assignedEmployee?.isFromSearch == 1 ? (
                                        <Tag closable onClose={() => setAssignedEmployee()} style={{ marginBottom: '5px', display: 'flex', alignItems: 'center', columnGap: '10px', width: 'fit-content' }}>
                                        <div className="employeeProfile">
                                            <Avatar size={20} style={{ background: 'lightgrey' }} src={assignedEmployee?.emp?.metadata?.imageURL || <UserOutlined />} />
                                        </div>
                                        {assignedEmployee?.emp?.firstname} {assignedEmployee?.emp?.lastname || ""}
                                        </Tag>
                                    ) : null}

                                    {assignedAgency ? (
                                        <Tag closable onClose={() => { setAssignedEmployee(); setAssignedAgency() }} style={{ marginBottom: '5px', display: 'flex', alignItems: 'center', columnGap: '10px', width: 'fit-content' }}>
                                        {agencyData?.agencies?.agencies?.find((agency) => agency?._id == assignedAgency)?.suppliername}
                                        </Tag>
                                    ) : null}

                                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px', flexShrink: 0, marginBottom: '12px', paddingRight:'2px' }}>
                                        <div style={{ width: '100%' }}>
                                            <Dropdown
                                                open={searchPopup}
                                                onOpenChange={(flag) => { setSearchPopup(flag); if(!flag) setSearch(""); }}
                                                trigger={["click"]}
                                                // overlayClassName="associationCustomPopover"
                                                dropdownRender={() => (
                                                    <div className="" style={{ paddingTop:'6px', width: '100%', background: '#fff', borderRadius: 8, boxShadow: '0 6px 16px rgba(0,0,0,0.12)', flexDirection: 'column', maxHeight:'100vh' }}>
                                                        <div className="association-sidebar" style={{ width: '100%', display: 'flex', flexDirection: 'row', overflowY: 'visible', padding: 0, borderBottom: '1px solid #f0f0f0', marginBottom:'12px' }} ref={searchSegmentRef}>
                                                            <div className={activeAssociatedModule == "employee" ? "popoverdataitem activeTab" : "popoverdataitem"} style={{ flex: 1, textAlign: 'center' }} onClick={() => { setSearch(""); setEmpSearchResult([]); setActiveAssociateModule("employee"); }}>
                                                                Employee
                                                            </div>
                                                            <div className={activeAssociatedModule == "agency" ? "popoverdataitem activeTab" : "popoverdataitem"} style={{ flex: 1, textAlign: 'center' }} onClick={() => { setSearch(""); setActiveAssociateModule("agency"); }}>
                                                                Supplier Staff
                                                            </div>
                                                        </div>

                                                        <div className="" style={{width:'450px',}} ref={searchDetailSegmentRef}>
                                                            <div className="popover-data" style={{ overflowY: 'scroll', height: '20vh' }}>
                                                                {activeAssociatedModule == "employee" ?
                                                                empSearchDataLoading ? (
                                                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                                                        <Spinner />
                                                                    </div>
                                                                ) : EmployeeSearchResult?.length > 0 ? (
                                                                    EmployeeSearchResult?.map((employee) => {
                                                                    const lastname = employee?.lastname ? employee?.lastname : "";
                                                                    const firstname = employee?.firstname ? employee?.firstname : "";

                                                                    return (
                                                                        <div className="popoverdataitem" onClick={() => { setSearchPopup(false); setFailureChecks(null); checkEmployeeIfSuitable(employee); }}>
                                                                            <div style={{ display: 'flex', columnGap: '12px' }}>
                                                                                <div className="employeeProfile">
                                                                                    <Avatar size={40} style={{ background: 'lightgrey' }} src={employee?.metadata?.imageURL || <UserOutlined />} />
                                                                                </div>
                                                                                <div>
                                                                                    <div>{firstname + " " + lastname}</div>

                                                                                </div>


                                                                            </div>
                                                                        </div>
                                                                    );
                                                                    })
                                                                ) : debouncedSearch?.length > 0 ? (
                                                                    <div className="popoverdataitem" style={{ textAlign: 'center', color: '#8c8c8c', cursor: 'default' }}>
                                                                        No employee found
                                                                    </div>
                                                                ) : 
                                                                    <div className="popoverdataitem" style={{ textAlign: 'center', color: '#8c8c8c', cursor: 'default' }}>
                                                                        Start search to find employee
                                                                    </div>
                                                                :
                                                                (
                                                                    <div className="addDutyAgencySelect">
                                                                    <Form.Item>
                                                                        <Select
                                                                        allowClear
                                                                        showSearch
                                                                        optionFilterProp="children"
                                                                        className="custom-select mb16"
                                                                        style={{ width: '100%' }}
                                                                        placeholder="Search supplier"
                                                                        suffixIcon={agencyLoading ? <Spinner /> : <div className="dropdowncaret"></div>}
                                                                        loading={agencyLoading}
                                                                        onChange={(e) => { setAssignAgencyLocally(e); setAssignedEmployee(null); }}
                                                                        >
                                                                        {!agencyLoading && agencyData?.agencies?.agencies?.length > 0 ?
                                                                            agencyData?.agencies?.agencies?.map((agency, index) => {
                                                                            return (
                                                                                <Option key={index} value={agency?._id}>{agency?.suppliername}</Option>
                                                                            );
                                                                            })
                                                                            :
                                                                            <Option disabled>No suppliers found</Option>
                                                                        }
                                                                        </Select>
                                                                        {assignAgencyLocally && (
                                                                        <button className="drawer-filled-btn" onClick={() => { setAssignedAgency(assignAgencyLocally); setSearchPopup(false); }}>Assign to supplier</button>
                                                                        )}
                                                                    </Form.Item>

                                                                    {assignAgencyLocally && (
                                                                        <Form.Item>
                                                                        <Select
                                                                            showSearch
                                                                            optionFilterProp="children"
                                                                            className="custom-select"
                                                                            style={{ width: '98%' }}
                                                                            placeholder="Select Employee"
                                                                            suffixIcon={agencyEmployeeLoading ? <Spinner /> : <div className="dropdowncaret"></div>}
                                                                            loading={agencyEmployeeLoading}
                                                                            disabled={agencyEmployeeLoading}
                                                                            value={assignedEmployee && assignedEmployee?._id}
                                                                            onChange={(e) => { setSearchPopup(false); setFailureChecks(null); checkEmployeeIfSuitable(agencyEmployee?.getEmployeeForScheduleSearch?.response?.find((emp) => emp?._id == e)); }}
                                                                        >
                                                                            {agencyEmployee?.getEmployeeForScheduleSearch?.response?.map((employee) => {
                                                                            return (
                                                                                <Option value={employee?._id}>{employee?.firstname} {employee?.lastname || ""}</Option>
                                                                            );
                                                                            })}
                                                                        </Select>
                                                                        </Form.Item>
                                                                    )}
                                                                    </div>
                                                                )}
                                                            </div>

                                                            {activeAssociatedModule == "employee" && (
                                                                <div
                                                                className="popoverdataitem"
                                                                style={{ color: '#0091ae', fontWeight: 500, borderTop: '1px solid #f0f0f0' }}
                                                                onClick={() => { setSearchPopup(false); setNewEmployeeData([]); setNewEmployeeModal(true); }}
                                                                >
                                                                    <FontAwesomeIcon icon={faPlus} style={{ marginRight: '8px' }} />
                                                                    Create new employee
                                                                </div>
                                                            )}

                                                        </div>
                                                    </div>
                                                )}
                                            >
                                                <Input
                                                    className="generic-input-control"
                                                    readOnly={activeAssociatedModule !== "employee"}
                                                    suffix={<FontAwesomeIcon style={{ color: '#0091ae' }} icon={faSearch} />}
                                                    // style={{ cursor: 'pointer', fontWeight: '400', fontSize: '13px', color: 'gray' }}
                                                    placeholder={
                                                        searchPopup && activeAssociatedModule === "employee"
                                                            ? "Search employee"
                                                            : assignedAgency ? "1 Supplier Allocated" : assignedEmployee ? "1 Employee Allocated" : " Employee / Supplier Allocate"
                                                    }
                                                    value={search}
                                                    autoComplete="off"
                                                    onChange={(e) => { setSearchPopup(true); handelSearch(e.target.value); }}
                                                    onClick={() => setSearchPopup(!searchPopup)}
                                                    ref={searchRef}
                                                />
                                            </Dropdown>

                                            {newEmployeeModal && (
                                                <FormDrawer
                                                    objectData={newEmployeeSchema}
                                                    objectLoading={newEmployeeObjectLoading}
                                                    visible={newEmployeeModal}
                                                    refetch={newEmployeeObjectRefetch}
                                                    setBtn={setNewEmployeeBtnEnable}
                                                    setData={setNewEmployeeData}
                                                    data={newEmployeeData}
                                                    isBtnEnable={newEmployeeBtnEnable}
                                                    isoverlay={newEmployeeOverlay}
                                                    setIsOverlay={setNewEmployeeOverlay}
                                                    loading={newEmployeeProcessLoading}
                                                    onClose={() => setNewEmployeeModal(false)}
                                                    handelSubmit={handelNewEmployeeSubmit}
                                                    to={"/employee/editform"}
                                                    from={"/user/employee"}
                                                    title={objectType.Employee}
                                                    objectType={objectType.Employee}
                                                />
                                            )}
                                        </div>
                                    </div>

                                    {trainUnTrainedLoading ? (
                                        <div style={{ display: 'table', margin: 'auto', textAlign: 'center', width: '100%' }}>
                                        <Spinner />
                                        </div>
                                    ) : true ? (
                                        <>
                                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', marginBottom: '12px', border: '1px solid #f0f0f0', borderRadius: '4px' }}>
                                            <div style={{ background: '#e5f5f8', letterSpacing: '0.4', padding: '5px', fontWeight: '400', fontSize: '13px', flexShrink: 0 }}>Suitable Employees</div>
                                            <div style={{ flex: 1, overflow: 'auto', padding: '8px' }}>
                                            {trainedEmp?.map((emp) => {
                                                return (
                                                <div className={assignedEmployee?._id == emp?._id ? "suitable-emp activeTab" : "suitable-emp"}   >
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <div style={{ display: 'flex', gap: '15px' }} onClick={() => setAssignedEmployee({ _id: emp?._id, isSuitable: 1 })} >

                                                        {emp?.metadata?.imageURL ? (
                                                        <Avatar size={40} src={emp?.metadata?.imageURL} />
                                                        ) : (
                                                        <Avatar size={40} src={<UserOutlined />} style={{ background: 'rgba(0, 0, 0, 0.25)' }} />
                                                        )}
                                                        <div style={{ display: 'flex', gap: '5px', flexDirection: 'column' }}>
                                                            <span style={{ fontSize: '13px' }}>{emp?.firstname + " " + (emp?.lastname || "")}</span>
                                                            <span style={{ fontSize: '10px' }}>{emp?.metadata?.employmenttype ? emp?.metadata?.employmenttype : '--'}</span>


                                                        </div>
                                                    </div>

                                                    {assignedEmployee?._id == emp?._id ? (
                                                        <FontAwesomeIcon icon={faTimes} className="close" style={{ right: '0', position:'static', top:'-20px' }} onClick={() => setAssignedEmployee()} />
                                                    ) : null}
                                                    </div>
                                                </div>
                                                );
                                            })}
                                            </div>
                                        </div>

                                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', border: '1px solid #f0f0f0', borderRadius: '4px' }}>
                                            <div style={{ background: '#e5f5f8', letterSpacing: '0.4', padding: '5px', fontWeight: '400', fontSize: '13px', flexShrink: 0 }}>
                                            Other Employees On Site <small style={{ color: 'red' }}> (May cause checks violation) </small>
                                            </div>
                                            <div style={{ flex: 1, overflow: 'auto', padding: '8px' }}>
                                            {otherEmp?.map((emp) => {
                                                return (
                                                <div className={assignedEmployee?._id == emp?._id ? "suitable-emp activeTab" : "suitable-emp"}>
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <div style={{ display: 'flex', gap: '15px' }} onClick={() => { setFailureChecks(null); checkEmployeeIfSuitable(emp); }}>
                                                        <div className="employeeProfile">
                                                        {emp?.metadata?.imageURL ? (
                                                            <Avatar size={40} src={emp?.metadata?.imageURL} />
                                                        ) : (
                                                            <div className="employeeProfile">
                                                            <Avatar size={40} src={<UserOutlined />} style={{ background: 'lightgrey' }} />
                                                            </div>
                                                        )}
                                                        </div>
                                                        <div style={{ display: 'flex', gap: '5px', flexDirection: 'column' }}>
                                                        <span style={{ fontSize: '13px' }}>{emp?.firstname + " " + (emp?.lastname || "")}</span>
                                                        <span style={{ fontSize: '10px' }}>{emp?.metadata?.employmenttype ? emp?.metadata?.employmenttype : '--'}</span>
                                                        </div>
                                                    </div>
                                                    {assignedEmployee?._id == emp?._id ? (
                                                        <FontAwesomeIcon icon={faTimes} style={{ paddingRight: '16px' }} onClick={() => setAssignedEmployee()} />
                                                    ) : null}
                                                    </div>
                                                </div>
                                                );
                                            })}
                                            </div>
                                        </div>
                                        </>
                                    ) : null}
                                    </div>
                                )}
                            
                            </div>

                        </div>
                    }
                                        
                </React.Fragment>
            </Modal>
            <CheckFailureModal visible={checkFailVisible} save={setAssignedEmployee} failureChecks={failureChecks} closeForSave={()=>{setCheckFailVisible(!checkFailVisible)}} close={()=>{setCheckFailVisible(!checkFailVisible); setFailureChecks(null);}} />
            {scheduleAssistantVisible && (
                <ScheduleAssistantModal
                    visible={scheduleAssistantVisible}
                    close={() => setScheduleAssistantVisible(false)}
                    site={site}
                    area={area}
                    title={title}
                    shiftStartTime={shiftStartTime}
                    shiftEndTime={shiftEndTime}
                    shiftTime={shiftTime}
                    allowedSkilledForSpecificArea={allowedSkilledForSpecificArea}
                    optionalSkilledForSpecificArea={optionalSkilledForSpecificArea}
                    payLevelIds={[dutyType]}
                    onSelectEmployee={(emp) => {
                        setFailureChecks(null);
                        checkEmployeeIfSuitable(emp);
                    }}
                />
            )}
            {
                assignTaskModal &&
                <TaskModal
                    selectedTasks={selectedTasks} setSelectedTasks={setSelectedTasks}
                    selectedCheckpoints={selectedCheckpoints} setSelectedCheckpoints={setSelectedCheckpoints}
                    visible={assignTaskModal} handelSubmit={()=>setAssignTaskModal(false)}
                    standAlone={true}
                    close={()=>setAssignTaskModal(false)}
                    sitegroupId={site?.sitegroupId}
                    siteId={site?._id}
                    shiftStartTime={shiftStartTime}
                    shiftEndTime={shiftEndTime}
                    associatedSiteGroupLocationId={selectedTasks?.length>0? selectedTasks[0]?.associatedSiteGroupLocationId : null}
                    initialTab={taskModalInitialTab}
                    lockInitialTab={true}
                />
            }
        </>
    )
}

